import React, {Component} from 'react';
import {Layout} from '../shared/components/common/layout/Layout';
export class App extends Component {
    render() {
        const {Template, hideHeader} = require('slp-template');
        return (
            <Layout hideHeader={hideHeader}>
                <Template />
            </Layout>
        );
    }
}
